import { Model } from '../abstracts/model';

export class FilterValueModel extends Model {
  id: number;
  slug: string;
  title: string;
  additional: string;
  description: string;
}
